// extracted by mini-css-extract-plugin
export default {"content":"style_content__Eze2j","title":"style_title__U4Cny","noAccess":"style_noAccess__SIZtU"};